'use client';
import { checkDeviceType } from '@benzinga/device-utils';
import { PushSubscriber } from '@benzinga/auth-ui';
import Hooks, { NoFirstRender } from '@benzinga/hooks';

export interface AdditionalScriptsProps {
  embeddedWidget?: boolean;
  disablePushPrompt?: boolean;
}

export default function AdditionalScripts({ pageProps }: { pageProps: AdditionalScriptsProps }) {
  const isDesktop = Hooks.useHydrate(checkDeviceType().isDesktop(), false);
  const showPushSubscriber = isDesktop && !pageProps.disablePushPrompt;

  return (
    !pageProps.embeddedWidget && (
      <>
        <script async src="https://accounts.google.com/gsi/client" />
        <link rel="preconnect" href="https://logx.optimizely.com" />
        {showPushSubscriber && (
          <NoFirstRender>
            <PushSubscriber position="bottom-left" />
          </NoFirstRender>
        )}
      </>
    )
  );
}
